import Vue from 'vue';

// router
import router from './router.js';

// axios
import axios from 'axios';
import VueAxios from 'vue-axios';
Vue.use(VueAxios, axios);
Vue.axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;
Vue.axios.defaults.headers.common['Accept-Language'] = 'ar';

// instantiation
Vue.config.productionTip = false;
import App from './App.vue';

new Vue({
  router,
  render: h => h(App)
}).$mount('#app') 
